import React, { useState } from "react";
import styled from "styled-components";

import { Text, colors } from "@trailhead/asurion-ui";

import {
  FlexColumnContainerWithJustifyCenter,
  FlexRowContainerWithJustifyCenter,
} from "../layout/StyledComponents";
import { RatingStar } from "./RatingStar";


const RatingSurveyContainer = styled(FlexColumnContainerWithJustifyCenter)`
  width: 100%;
  align-items: center;
  height: 163px;
  border-bottom: 1px solid ${colors.disabledBackground};
  border-top: 1px solid ${colors.disabledBackground};
  gap: 16.59px;
`;

const TitleText = styled(Text)`
  text-align: center;
`;

const StarsContainer = styled(FlexRowContainerWithJustifyCenter)`
  align-items: center;
  padding: 8px;
`;

const SingleStarContainer = styled(FlexColumnContainerWithJustifyCenter)`
  font-size: 14px;
  margin: 8px;
  align-items: center;
`;

interface RatingSurveyProps {
  titleText: string;
  onSubmit: (rating: number) => void;
}

export const RatingSurvey = ({ titleText, onSubmit }: RatingSurveyProps) => {
  const [rating, setRating] = useState<number>();
  const [hoverRating, setHoverRating] = useState<number>();

  return (
    <RatingSurveyContainer>
      <TitleText size={4} weight="feather">
        {titleText}
      </TitleText>
      <StarsContainer>
        {[1, 2, 3, 4, 5].map((index: number) => (
          <SingleStarContainer key={index}>
            <RatingStar
              hoverRating={hoverRating || 0}
              rating={rating || 0}
              index={index}
              setHoverRating={setHoverRating}
              setRating={setRating}
              onSubmit={onSubmit}
            />
          </SingleStarContainer>
        ))}
      </StarsContainer>
    </RatingSurveyContainer>
  );
};
